/* eslint-disable no-undef */
import React from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ButtonImageLink from '../../../../components/NovoSistema/ButtonImageLink';

export default function TemplateGestaoDePessoas() {
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Gestão de Pessoas" linkIcon="/images/icons/morePeople.svg" />
        <ButtonImageLink name="logo gen.te" image="/images/logos/logo-gen-te.PNG" link="#" />
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
